import Answer from "../answer"
import React, { useCallback, useState, useReducer, useMemo, useEffect } from "react"
import useUserChooseAnswer from "../../modules/user/hooks/use-user-answer";
import useUserAnswers from "../../modules/user/hooks/use-user-answers";
import useTrack from "../../modules/game/hooks/use-track";
import AnswerPanel from "../answer-panel";
import './style.scss';
import useGtagEvent from "../../utils/google-analitics/use-gtag-event";

type Props = {
    trackId: TrackId
}

const AnswerList: React.FunctionComponent<Props> = ({ trackId }) => {
    const userAnswer = useUserChooseAnswer(trackId);
    const userAnswers = useUserAnswers(trackId);
    const { track } = useTrack(trackId);
    const [opened, setOpened] = useState<SchoolId | null>(null);
    const sendEvent = useGtagEvent();

    const [itemsInRow, updateItemsInRow] = useReducer((state) => {


        if (Boolean(window.matchMedia)) {
            if (window.matchMedia('(max-width: 600px)').matches) {
                return 1;
            } else if (window.matchMedia('(max-width: 1000px)').matches) {
                return 2;
            }

            return 3;
        } else {
            const width = window.innerWidth;

            console.log(width)

            if (width < 600) {
                return 1;
            } else if (width < 1000) {
                return 2;
            }

            return 3;
        }

    }, 3)

    const onSchoolSelected = useCallback((id: SchoolId) => {
        userAnswer(id);
        sendEvent('select_school', `${trackId}_${id}`)
    }, [userAnswer, sendEvent, trackId])

    const isAnswerUsed = useCallback((id: SchoolId) => {
        return userAnswers.indexOf(id) !== -1;
    }, [userAnswers])

    const onSchoolClick = useCallback((id: SchoolId) => {
        setOpened(id)
    }, []);

    const answerRows: SchoolId[][] = useMemo(() => {
        if (track) {
            return track.answers.reduce<any[]>((prev, next, index) => {
                const resultIndex = Math.floor(index / itemsInRow);

                if (!prev[resultIndex]) {
                    prev[resultIndex] = [];
                }

                prev[resultIndex].push(next);

                return prev;
            }, [])
        } else {
            return []
        }
    }, [track, itemsInRow])


    useEffect(() => {
        window.addEventListener('resize', updateItemsInRow);
        updateItemsInRow();

        return () => {
            window.removeEventListener('resize', updateItemsInRow);
        }

    }, [updateItemsInRow])

    return (
        <>
            <div className="answers-list">

                {
                    answerRows.map((ar, index) => (
                        <div className="answers-row-with-panel" key={index}>
                            <div className="answers-row row page-container">
                                {
                                    ar.map((a, index) => {
                                        return <Answer key={index} schoolId={a} onSelected={onSchoolSelected} used={isAnswerUsed(a)} onClick={onSchoolClick} />
                                    }
                                    )
                                }
                            </div>
                            {/* {opened && track && Math.floor(track.answers.indexOf(opened) / itemsInRow) === index && <AnswerPanel schoolId={opened} onSelected={onSchoolSelected} />} */}
                            <div style={{
                                transform: `scaleY(${Boolean(opened && track && Math.floor(track.answers.indexOf(opened) / itemsInRow) === index) ? '1' : '0'})`,
                                transformOrigin: 'top',
                                transition: '.3s',
                                overflow: 'hidden'
                            }}>
                                {
                                    opened &&
                                    track &&
                                    Math.floor(track.answers.indexOf(opened) / itemsInRow) === index &&
                                    <AnswerPanel onClose={() => setOpened(null)} schoolId={opened} onSelected={onSchoolSelected} />
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default AnswerList;
